/* ── MODAL ── */ (function() {
    const overlay = document.getElementById("modal");
    const modalImg = document.getElementById("modal-img");
    const runnerInner = document.getElementById("modal-runner-inner");
    function openModal(btn) {
        const title = btn.dataset.title || "";
        const num = btn.dataset.num || "";
        /* récupère le src traité par Parcel depuis la carte */ const card = btn.closest(".artwork-card");
        const cardImg = card ? card.querySelector(".artwork-image img") : null;
        const imgSrc = cardImg ? cardImg.src : "";
        /* image */ modalImg.innerHTML = "";
        if (imgSrc) {
            const img = document.createElement("img");
            img.alt = title;
            img.src = imgSrc;
            modalImg.appendChild(img);
        } else modalImg.textContent = num;
        /* build scrolling band — repeat title 6× for seamless loop */ const chunk = Array.from({
            length: 6
        }, ()=>`<span class="mr-word">${title}</span><span class="mr-dot">\u{25C6}</span>`).join("");
        runnerInner.innerHTML = chunk + chunk; /* ×2 for CSS -50% loop */ 
        overlay.classList.add("open");
        document.body.style.overflow = "hidden";
    }
    function closeModal() {
        overlay.classList.remove("open");
        document.body.style.overflow = "";
        overlay.querySelector(".modal-box").style.width = "";
    }
    document.body.addEventListener("click", (e)=>{
        const btn = e.target.closest(".open-modal");
        if (btn) {
            e.preventDefault();
            openModal(btn);
            return;
        }
        const artImg = e.target.closest(".artwork-image");
        if (artImg) {
            const card = artImg.closest(".artwork-card");
            const modalBtn = card ? card.querySelector(".open-modal") : null;
            if (modalBtn) {
                e.preventDefault();
                openModal(modalBtn);
                return;
            }
        }
        /* clic en dehors de l'image = ferme */ if (overlay.classList.contains("open") && !e.target.closest(".modal-img img")) closeModal();
    });
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") closeModal();
    });
})();
/* ── HEADER CURSOR TRAIL ── */ (function() {
    const THROTTLE = 110;
    const LIFETIME = 700;
    let idx = 0;
    let lastSpawn = 0;
    let srcs = [];
    window.addEventListener("load", ()=>{
        /* récupère les src déjà traitées par Parcel depuis les cartes */ srcs = Array.from(document.querySelectorAll("#loop-content .artwork-image img")).map((img)=>img.src);
        document.querySelectorAll("header").forEach(setup);
    });
    function spawn(header, x, y) {
        if (!srcs.length) return;
        const el = document.createElement("div");
        el.className = "cursor-trail-img";
        el.style.left = x + "px";
        el.style.top = y + "px";
        el.style.setProperty("--rot", Math.random() * 22 - 11 + "deg");
        const img = document.createElement("img");
        img.src = srcs[idx % srcs.length];
        idx++;
        el.appendChild(img);
        header.appendChild(el);
        requestAnimationFrame(()=>el.classList.add("visible"));
        setTimeout(()=>{
            el.classList.remove("visible");
            setTimeout(()=>el.remove(), 400);
        }, LIFETIME);
    }
    function setup(header) {
        header.addEventListener("mousemove", (e)=>{
            if (window.innerWidth <= 640) return;
            const now = Date.now();
            if (now - lastSpawn < THROTTLE) return;
            lastSpawn = now;
            const rect = header.getBoundingClientRect();
            spawn(header, e.clientX - rect.left, e.clientY - rect.top);
        });
    }
})();
/* ── THEME TOGGLE ── */ (function() {
    const logo = document.getElementById("site-logo");
    logo.addEventListener("click", ()=>{
        document.body.classList.toggle("theme-orange");
    });
})();
/* ── CUSTOM CURSOR ── */ (function() {
    const cursor = document.getElementById("cursor");
    const hoverTargets = "a, button, [role='button'], .photo, .open-modal";
    document.addEventListener("mousemove", (e)=>{
        cursor.style.left = e.clientX + "px";
        cursor.style.top = e.clientY + "px";
        cursor.style.opacity = "1";
    });
    document.addEventListener("mouseover", (e)=>{
        if (e.target.closest(hoverTargets)) cursor.classList.add("hovered");
    });
    document.addEventListener("mouseout", (e)=>{
        if (e.target.closest(hoverTargets)) cursor.classList.remove("hovered");
    });
})();
/* ── FULLSCREEN MENU ── */ (function() {
    const toggle = document.getElementById("menu-toggle");
    const menu = document.getElementById("fullscreen-menu");
    let isOpen = false;
    let closing = false;
    function openMenu() {
        isOpen = true;
        menu.classList.remove("closing");
        menu.classList.add("open");
        menu.setAttribute("aria-hidden", "false");
        toggle.classList.add("open");
        document.body.style.overflow = "hidden";
    }
    function closeMenu() {
        if (!isOpen || closing) return;
        closing = true;
        menu.classList.add("closing");
        menu.classList.remove("open");
        toggle.classList.remove("open");
        document.body.style.overflow = "";
        setTimeout(()=>{
            menu.classList.remove("closing");
            menu.setAttribute("aria-hidden", "true");
            isOpen = false;
            closing = false;
        }, 750);
    }
    toggle.addEventListener("click", ()=>isOpen ? closeMenu() : openMenu());
    /* ferme au clic sur un lien */ menu.querySelectorAll(".fs-link").forEach((link)=>{
        link.addEventListener("click", closeMenu);
    });
    /* ferme avec Escape */ document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") closeMenu();
    });
})();
/* ── BACK TO TOP ── */ (function() {
    const btn = document.getElementById("back-to-top");
    window.addEventListener("scroll", ()=>{
        btn.classList.toggle("visible", window.scrollY > window.innerHeight * 0.5);
    }, {
        passive: true
    });
    btn.addEventListener("click", ()=>window.scrollTo({
            top: 0,
            behavior: "smooth"
        }));
})();
/* ── NAV SCROLL ── */ document.addEventListener("click", (e)=>{
    const link = e.target.closest(".nav-link");
    if (!link) return;
    e.preventDefault();
    const id = link.getAttribute("href").slice(1);
    const target = document.querySelector("#loop-content #" + id);
    if (!target) return;
    const navH = document.querySelector(".nav-band")?.offsetHeight || 0;
    const top = target.getBoundingClientRect().top + window.scrollY - navH;
    window.scrollTo({
        top,
        behavior: "smooth"
    });
});
/* ── SCROLL REVEAL ── */ function setupReveal(root) {
    const selectors = [
        {
            sel: ".ghost-title",
            delay: 0
        },
        {
            sel: ".meta",
            delay: 1
        },
        {
            sel: ".description",
            delay: 2
        },
        {
            sel: ".artwork-info .btn",
            delay: 3
        },
        {
            sel: ".ed-text",
            delay: 0
        },
        {
            sel: ".artwork-image img",
            delay: 0
        }
    ];
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.12
    });
    selectors.forEach(({ sel, delay })=>{
        root.querySelectorAll(sel).forEach((el)=>{
            el.setAttribute("data-reveal", "up");
            if (delay) el.setAttribute("data-delay", delay);
            observer.observe(el);
        });
    });
}
window.addEventListener("load", ()=>setupReveal(document));
/* ── DOT BACKGROUND ── */ class DotBackground {
    constructor(section, options = {}){
        this.section = section;
        this.canvas = document.createElement("canvas");
        this.canvas.className = "dot-bg-canvas";
        section.prepend(this.canvas);
        this.ctx = this.canvas.getContext("2d");
        this.gap = options.gap ?? 26;
        this.dotColor = options.dotColor ?? "rgba(255,255,255,0.45)";
        this.minRadius = options.minRadius ?? 1.0;
        this.maxRadius = options.maxRadius ?? 5;
        this.influence = options.influence ?? 110;
        this.ease = options.ease ?? 0.11;
        this.mouse = {
            x: -9999,
            y: -9999
        };
        this.dots = [];
        this._init();
    }
    _init() {
        this._resize();
        this._bindEvents();
        this._loop();
    }
    _resize() {
        const r = this.section.getBoundingClientRect();
        this.canvas.width = this.W = r.width;
        this.canvas.height = this.H = r.height;
        this._buildDots();
    }
    _buildDots() {
        this.dots = [];
        const offX = this.W % this.gap / 2;
        const offY = this.H % this.gap / 2;
        for(let y = offY; y < this.H + this.gap; y += this.gap)for(let x = offX; x < this.W + this.gap; x += this.gap)this.dots.push({
            x,
            y,
            radius: this.minRadius
        });
    }
    _bindEvents() {
        this.section.addEventListener("mousemove", (e)=>{
            const r = this.section.getBoundingClientRect();
            this.mouse.x = e.clientX - r.left;
            this.mouse.y = e.clientY - r.top;
        });
        this.section.addEventListener("mouseleave", ()=>{
            this.mouse.x = this.mouse.y = -9999;
        });
        new ResizeObserver(()=>this._resize()).observe(this.section);
    }
    _loop() {
        const { ctx, W, H, dots, mouse, minRadius, maxRadius, influence, ease } = this;
        const color = document.body.classList.contains("theme-orange") ? "rgba(0,0,0,0.25)" : this.dotColor;
        ctx.clearRect(0, 0, W, H);
        for (const d of dots){
            const dx = mouse.x - d.x, dy = mouse.y - d.y;
            const t = Math.max(0, 1 - Math.sqrt(dx * dx + dy * dy) / influence);
            d.radius += (minRadius + (maxRadius - minRadius) * t * t - d.radius) * ease;
            ctx.beginPath();
            ctx.arc(d.x, d.y, d.radius, 0, Math.PI * 2);
            ctx.fillStyle = color;
            ctx.fill();
        }
        requestAnimationFrame(()=>this._loop());
    }
}
function initDots(root) {
    root.querySelectorAll(".editorial-section, .artwork-card.v-dark").forEach((el)=>{
        new DotBackground(el, {
            gap: 26,
            minRadius: 1.0,
            maxRadius: 5,
            influence: 115,
            dotColor: "rgba(255,255,255,0.4)"
        });
    });
}
window.addEventListener("load", ()=>initDots(document));
/* ── PARALLAX GALLERY ── */ function initSlider(section) {
    const bgText = section.querySelector(".slider-bg-text");
    const allPhotos = section.querySelectorAll(".photo");
    function onScroll() {
        // désactive le parallax sur mobile (grille statique)
        if (window.innerWidth <= 640) return;
        const rect = section.getBoundingClientRect();
        const offset = -rect.top;
        if (bgText) bgText.style.transform = `translateY(${offset * 0.3}px)`;
        allPhotos.forEach((photo)=>{
            const rot = parseFloat(photo.dataset.rotate || 0);
            const speed = parseFloat(photo.dataset.speed || 1);
            const dy = offset * (speed - 1) * 0.15;
            photo.style.transform = `rotate(${rot}deg) translateY(${dy}px)`;
        });
    }
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
    window.addEventListener("resize", onScroll, {
        passive: true
    });
    onScroll();
}
window.addEventListener("load", ()=>{
    document.querySelectorAll(".slider-section").forEach(initSlider);
});
/* ── INFINITE PAGE LOOP ── */ window.addEventListener("load", ()=>{
    const original = document.getElementById("loop-content");
    // Clone the entire page content and place it directly after the original
    const clone = original.cloneNode(true);
    clone.id = "loop-content-clone";
    clone.setAttribute("aria-hidden", "true");
    // The cloned nav must NOT be sticky (otherwise two sticky navs appear simultaneously)
    const clonedNav = clone.querySelector(".nav-band");
    if (clonedNav) clonedNav.style.position = "static";
    document.body.appendChild(clone);
    // init sliders + reveal + dots inside the clone too
    clone.querySelectorAll(".slider-section").forEach(initSlider);
    setupReveal(clone);
    initDots(clone);
    // Height of one full "loop" = height of original block
    function getHalf() {
        return original.offsetHeight;
    }
    window.addEventListener("scroll", ()=>{
        const half = getHalf();
        if (window.scrollY >= half) // Teleport back to the equivalent position in the first copy — seamless
        window.scrollTo(0, window.scrollY - half);
        // Also handle upward scroll past the top
        if (window.scrollY < 0) window.scrollTo(0, window.scrollY + half);
    }, {
        passive: true
    });
});

//# sourceMappingURL=index.f146b5b4.js.map
